import { useEffect, useState } from 'react'
import { supabase } from '../../api/supabase'

interface Row { id: string; action: string; field: string | null; old_value: string | null; new_value: string | null; user_email: string; reason: string | null; auth_code_used: boolean; created_at: string }

export default function InvoiceHistory({ invoiceId }: { invoiceId: string }) {
  const [rows, setRows] = useState<Row[] | null>(null)
  const [error, setError] = useState<string | null>(null)
  useEffect(() => {
    supabase.from('invoice_audit_log').select('*').eq('invoice_id', invoiceId).order('created_at', { ascending: false })
      .then(({ data, error }) => { if (error) setError(error.message); else setRows(data as Row[]) })
  }, [invoiceId])

  if (error) return <p className="text-sm text-red-600 dark:text-red-400">History unavailable: {error}</p>
  if (!rows) return <p className="text-sm text-gray-500">Loading…</p>
  if (rows.length === 0) return <p className="text-sm text-gray-500 dark:text-gray-400">No edits, voids or credits recorded for this invoice.</p>
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs">
        <thead><tr className="text-left text-gray-500 dark:text-gray-400 uppercase">
          <th className="py-1 pr-3">When</th><th className="pr-3">Who</th><th className="pr-3">Action</th><th className="pr-3">Field</th><th className="pr-3">Old → New</th><th>Reason</th>
        </tr></thead>
        <tbody className="text-gray-800 dark:text-gray-200">
          {rows.map(r => (
            <tr key={r.id} className="border-t border-gray-100 dark:border-gray-700 align-top">
              <td className="py-1.5 pr-3 whitespace-nowrap">{new Date(r.created_at).toLocaleString('en-GB')}</td>
              <td className="pr-3">{r.user_email}</td>
              <td className="pr-3 font-medium">{r.action}{r.auth_code_used && <span title="Authorisation code used"> 🔑</span>}</td>
              <td className="pr-3">{r.field || '—'}</td>
              <td className="pr-3">{r.old_value ?? '—'} → {r.new_value ?? '—'}</td>
              <td>{r.reason || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
